import(/* webpackMode: "eager" */ "/git-test/app/global-error.tsx");
